/**
 * English translations for Open E Masjid
 */
export const en = {
    common: {
        loading: "Loading...",
        error: "Error",
        success: "Success",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        create: "Create",
        update: "Update",
        submit: "Submit",
        back: "Back",
        next: "Next",
        previous: "Previous",
        search: "Search",
        filter: "Filter",
        filters: "Filters",
        clear: "Clear",
        yes: "Yes",
        no: "No",
        confirm: "Confirm",
        view: "View",
        close: "Close",
        home: "Home",
        welcome: "Welcome",
        manage: "Manage",
        add: "Add",
        actions: "Actions",
    },
    prayer: {
        times: "Prayer Times",
        fajr: "Fajr",
        sunrise: "Sunrise",
        dhuhr: "Dhuhr",
        asr: "Asr",
        maghrib: "Maghrib",
        isha: "Isha",
        current: "Current Prayer",
        next: "Next Prayer",
        countdown: "Countdown",
        schedule: "Prayer Schedule",
        updated: "Updated",
        source: "Source",
    },
    masjid: {
        name: "Masjid",
        masjids: "Masjids",
        location: "Location",
        address: "Address",
        contact: "Contact",
        about: "About",
        facilities: "Facilities",
        events: "Events",
        announcements: "Announcements",
        browse: "Browse Masjids",
        my_masjids: "My Masjids",
        create: "Create Masjid",
        total: "Total Masjids",
    },
    content: {
        title: "Content",
        create: "Create Content",
        upload: "Upload Content",
        my_content: "My Content",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        submitted: "Submitted",
        type: "Type",
        image: "Image",
        video: "Video",
        youtube: "YouTube",
        duration: "Duration",
        status: "Status",
    },
    profile: {
        title: "Profile",
        my_profile: "My Profile",
        edit: "Edit Profile",
        name: "Name",
        email: "Email",
        phone: "Phone Number",
        language: "Preferred Language",
        settings: "Settings",
        account: "Account",
    },
    admin: {
        dashboard: "Dashboard",
        admin_dashboard: "Admin Dashboard",
        approvals: "Approvals",
        pending_approvals: "Pending Approvals",
        users: "Users",
        registered_users: "Registered Users",
        content_management: "Content Management",
        display_management: "Display Management",
        applications: "Applications",
        admin_applications: "Admin Applications",
        settings: "Settings",
        manage_displays: "Manage Displays",
        manage_content: "Manage Content",
    },
    display: {
        title: "Display",
        configuration: "Configuration",
        status: "Status",
        online: "Online",
        offline: "Offline",
        last_updated: "Last Updated",
        brightness: "Brightness",
        volume: "Volume",
        orientation: "Orientation",
    },
    auth: {
        login: "Login",
        logout: "Logout",
        register: "Register",
        forgot_password: "Forgot Password",
        reset_password: "Reset Password",
        email: "Email",
        password: "Password",
        confirm_password: "Confirm Password",
    },
    validation: {
        required: "This field is required",
        invalid_email: "Invalid email address",
        invalid_phone: "Invalid phone number",
        min_length: "Minimum length is {{min}} characters",
        max_length: "Maximum length is {{max}} characters",
        password_mismatch: "Passwords do not match",
    },
    messages: {
        save_success: "Saved successfully",
        save_error: "Failed to save",
        delete_success: "Deleted successfully",
        delete_error: "Failed to delete",
        update_success: "Updated successfully",
        update_error: "Failed to update",
        create_success: "Created successfully",
        create_error: "Failed to create",
    },
    date: {
        today: "Today",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        week: "Week",
        month: "Month",
        year: "Year",
    },
    nav: {
        home: "Home",
        masjids: "Masjids",
        my_profile: "My Profile",
        my_content: "My Content",
        create_content: "Create Content",
        admin_dashboard: "Admin Dashboard",
        manage_applications: "Manage Applications",
        manage_displays: "Manage Displays",
        manage_content: "Manage Content",
        user_approvals: "User Approvals",
        settings: "Settings",
        notifications: "Notifications",
        logout: "Logout",
        profile: "Profile",
    },
    home: {
        welcome: "Welcome to Open E Masjid",
        subtitle: "Modern masjid management platform for Malaysian communities",
        quick_stats: "Quick Stats",
        quick_actions: "Quick Actions",
        recent_activity: "Recent Activity",
        no_activity: "No recent activity to display.",
        complete_profile: "Complete Your Profile",
        complete_profile_desc: "Finish setting up your profile to get the most out of Masjid Suite. Add your phone number, address, and select your home masjid.",
        view_edit_info: "View and edit your personal information",
        discover_masjids: "Discover masjids in your area",
        manage_apps_users: "Manage applications and users",
        add_new_masjid: "Add a new masjid to the system",
    },
    masjidList: {
        title: "Masjid Directory",
        subtitle: "Browse and discover Islamic centers in Malaysia",
        add_masjid: "Add Masjid",
        search_placeholder: "Search by name, description, or city",
        search_label: "Search masjids",
        filter_state: "Filter by State",
        clear_filters: "Clear Filters",
        no_results: "No masjids found",
        no_results_desc: "Try adjusting your search or filters",
        create_first: "Create your first masjid",
        no_masjids: "No Masjids Found",
        no_masjids_desc: "Be the first to add a masjid to our directory.",
        view_details: "View Details",
        city: "City",
        state: "State",
        contact: "Contact",
        loading: "Loading masjids...",
        error_load: "Failed to load masjids",
        all_states: "All States",
        showing_count: "Showing {{filtered}} of {{total}} masjids",
        add_first: "Add First Masjid",
        no_description: "No description available.",
        administrators: "Administrators",
    },
    myContent: {
        title: "My Content",
        subtitle: "Manage and track your content submissions",
        create_new: "Create New Content",
        filter_status: "Filter by Status",
        refresh: "Refresh Content",
        all_status: "All Status",
        loading: "Loading your content...",
        error_load: "Failed to load content",
        no_content: "No content submitted yet",
        no_filtered_content: "No {{status}} content found",
        no_content_desc: "Start by creating your first content submission.",
        no_filtered_desc: "Try changing the filter to see content with other statuses.",
        create_content: "Create Content",
        duration_label: "{{duration}}s duration",
        duration_help: "Display duration in seconds (5-300)",
        date_range: "{{start}} - {{end}}",
        submitted_to: "Submitted to: {{masjid}}",
        submitted_on: "Submitted: {{date}}",
        status_rejected: "This content was rejected. You can resubmit with modifications.",
        status_active: "This content has been approved and is active.",
        preview_content: "Preview Content",
        edit: "Edit",
        resubmit: "Resubmit",
        delete: "Delete",
        resubmit_title: "Resubmit Content",
        resubmit_desc: "Make any necessary changes before resubmitting your content for approval.",
        edit_title: "Edit Content",
        edit_desc: "Update your content information. Changes will retain the current approval status.",
        delete_title: "Delete Content",
        delete_warning: "This action cannot be undone!",
        delete_confirm: "Are you sure you want to delete this content?",
        delete_confirm_btn: "Yes, Delete",
        save_changes: "Save Changes",
        title_field: "Title",
        description_field: "Description (optional)",
        duration_field: "Duration (seconds)",
        start_date: "Start Date",
        end_date: "End Date",
        cancel: "Cancel",
        resubmit_approval: "Resubmit for Approval",
        status_pending: "Pending",
        status_active_label: "Active",
        status_rejected_label: "Rejected",
        status_expired: "Expired",
        type_image: "Image",
        type_youtube: "YouTube",
        qr_code_title: "QR Code Settings",
        qr_code_enabled: "Display QR Code",
        qr_code_url: "QR Code URL (optional)",
        qr_code_url_help: "Leave empty to use default public content page",
        qr_code_position: "QR Code Position",
        qr_position_tl: "Top Left",
        qr_position_tr: "Top Right",
        qr_position_bl: "Bottom Left",
        qr_position_br: "Bottom Right",
    },
};
//# sourceMappingURL=en.js.map